import { Center, FormControl, Text, forwardRef } from '@chakra-ui/react';
import * as React from 'react';

import { DragAndDropImageUpload } from '@/components/DragAndDropImageUpload';
import { EPrepImagesSource } from '@/graphql-types/globalTypes';

export const GroupProfileImagePicker = forwardRef<
  {
    value?: string;
    onChange: (value: string) => void;
    nonDraftImageProxy: string | null;
  },
  'div'
>((props, ref) => {
  return (
    <FormControl ref={ref}>
      <DragAndDropImageUpload
        value={props.value}
        onChange={props.onChange}
        aria-label="Group profile image"
        source={EPrepImagesSource.DEFAULT}
        imageInput={{ h: 96, w: 96, fit: 'fill', fill: 'solid' }}
        imageProps={{ h: '12', w: '12', borderRadius: 'base' }}
        nonDraftImageProxy={props.nonDraftImageProxy}
      />
      <Center w="full" mt="6">
        <Text color={'gray.500'}>The image size is 96px by 96px</Text>
      </Center>
    </FormControl>
  );
});
